export default __webpack_public_path__ + "static/line4-e6730ff5bfb0ad669b6b01aa1ddb40b3.webp";